import React from "react"
import { view } from "react-easy-state"
import { withRouter } from "react-router-dom"
import { isMobile } from "react-device-detect"
import { Icon, Button, Modal } from "antd"

import AskDoubt from "components/pages/students/AskDoubt"

import * as AuthHelper from "helpers/auth.helper"

const menuItems = [
  {
    label: "Courses",
    path: "/courses",
  },
  {
    label: "My doubts",
    path: "/doubts",
  },
  {
    label: "All doubts",
    path: "/doubts/all",
  },
  {
    label: "Profile",
    path: "/profile",
  },
]

const Header = (props) => {
  if (props.content) {
    return <div className="page-header">{props.content}</div>
  }

  if (isMobile) {
    return (
      <div className="page-header">
        <div className="top-logo">
          <div>
            <Button type="link" onClick={() => props.history.push("/")}>
              <h1>Learner</h1>
            </Button>
          </div>
        </div>
        <div className="top-menu">
          <Button className="menu-button" type="link" onClick={toggleTopMenu}>
            <Icon type="menu" />
          </Button>
          {AuthHelper.isLoggedIn() && (
            <Button type="link" className="logout-button" onClick={() => logout()}>
              <Icon type="logout" />
            </Button>
          )}
        </div>
        <div className="top-menu-dropdown">
          <ul>
            {menuItems.map((mi, i) => {
              return (
                <li key={i}>
                  <Button type="link" onClick={() => props.history.push(mi.path)}>
                    {mi.label}
                  </Button>
                </li>
              )
            })}
            <li>
              <AskDoubt
                buttonText="Ask a doubt"
                buttonStyle={{
                  width: "100%",
                  position: "initial",
                  display: "flex",
                  justifyContent: "center",
                }}
              />
            </li>
          </ul>
        </div>
      </div>
    )
  }

  return (
    <div className="page-header">
      <div className="top-logo">
        <div>
          <Button type="link" onClick={() => props.history.push("/")}>
            <h1>Learner</h1>
          </Button>
        </div>
      </div>
      <div className="top-menu">
        {menuItems.map((mi, i) => {
          return (
            <Button type="link" onClick={() => props.history.push(mi.path)} key={i}>
              {mi.label}
            </Button>
          )
        })}
        <AskDoubt
          buttonText="Ask a doubt"
          buttonType="link"
          buttonStyle={{
            position: "initial",
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
        <Button type="link" onClick={() => logout()}>
          <Icon type="logout" />
        </Button>
      </div>
    </div>
  )
}

const toggleTopMenu = () => {
  const menuDropdown = document.getElementsByClassName("top-menu-dropdown")

  if (!menuDropdown && menuDropdown.length === 0) return false

  menuDropdown[0].classList.toggle("opened")
}

const logout = () => {
  Modal.confirm({
    title: "Do you really want to logout?",
    okText: "Yes",
    cancelText: "No",
    onOk: () => {
      AuthHelper.logout()
    },
    onCancel: () => {},
  })
}

export default withRouter(view(Header))
